module.exports = __webpack_public_path__ + "img/CMEF-shanghai.c93723ab.png";